import { render, staticRenderFns } from "./TheSnapshotBundleEditDialog.vue?vue&type=template&id=1304502e&"
import script from "./TheSnapshotBundleEditDialog.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotBundleEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports